import styled from '@emotion/styled'

import { sectionTitle, sectionSubtitle, mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.large};
  margin-top: -5rem;
  ${mediaMax.xs}{
    margin-top: 0;
  }
`

export const Subtitle = styled.span`
  color: ${({ theme }) => theme.colors.lightGreen};
  ${sectionSubtitle()}
  margin-bottom: ${({ theme }) => theme.spacing.xxsmall};
`

export const Title = styled.p`
  ${sectionTitle()}
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.brown};
  ${mediaMax.xs}{
    font-size: 1.8rem;
    text-align: center;
  }
`
